import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { getDenormalizedDataEntityById } from '../../redux/entities';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
const getNormalizedDeviation = createSelector((state)=>state, (_, deviationId)=>deviationId, (state, deviationId)=>getDenormalizedDataEntityById(state, deviationSchema, deviationId));
export function useNormalizedDeviation(deviationId) {
    return useSelector((state)=>getNormalizedDeviation(state, deviationId));
}

//# sourceMappingURL=useNormalizedDeviation.js.map